import styled from 'styled-components'
import Background from '../../../../src/assets/background.svg'
import {useContext, useEffect, useMemo, useState} from 'react'
import {
    Typography,
    Button,
    Modal,
    Box,
    Alert,
    Snackbar,
    Switch,
    CircularProgress,
} from '@mui/material'
import GroupsIcon from '@mui/icons-material/Groups'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import {AuthContext} from '../../../contexts/auth'
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined'
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined'
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveAlt1Outlined'
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined'
import {AssistantApi} from '../../../services/AssistantApi.service'
import {HistoryContext} from '../../../contexts/history'
import {OrgMetrics} from '../../../types/orgUsersMetrics'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import SnackbarContent from '@mui/material/SnackbarContent'
import {getCurrentColors} from '../../../utils/colors'
import Coins from '../../../assets/coins.svg'
import GreenCoins from '../../../assets/GreenCoins.svg'
import MonthlyUsageReport from './MonthlyUsageReport'

const COLORS = getCurrentColors() // Importando as cores do tema atual

const Page = styled.div`
    height: 100vh;
    margin-top: 0;
    padding: 28px 40px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-y: auto;
    background-color: #f6f8fa;
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-position: right 370px;
    background-size: 800px;
    flex: 1;
    min-width: 0;
`

const Header = styled.div`
    width: 100%;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Body = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    background-color: #ffffff;
    min-height: 600px;
    min-width: 0;
`
const Menu = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-direction: column;
    width: 195px;
    border-right: 1px solid #e4e4e4;
    padding-top: 32px;
`

const MenuItem = styled.div<{isActive: boolean}>`
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px; /* Increased horizontal padding */
    cursor: pointer;
    font-weight: ${(props) => (props.isActive ? '600' : '400')};
    color: ${(props) => (props.isActive ? COLORS.primariaEscura : '#707070')};
    background-color: ${(props) =>
        props.isActive ? '#f0f0f0' : 'transparent'};
    width: fit-content;
    min-width: 100px;
    margin: 0 auto;
    border-radius: 50px;
    &:hover {
        background-color: #f0f0f0;
    }
`

const ButtonGroup = styled.div<{userInfo: boolean}>`
    display: flex;
    gap: 8px;
    margin-top: 16px;
    background-color: #f0f0f0;
    border-radius: 245px;
    justify-content: space-between;
    max-width: ${(props) => (props.userInfo ? '345px' : '135px')};
    padding: 3px;
`

const PerfilContainer = styled.div`
    flex: 1;
    width: 100%;
    background-color: #ffffff;

    margin-bottom: 24px;
    margin-left: 24px;
    margin-right: 24px;
    overflow: auto;
    flex-direction: column;
    min-width: 0;
`

const PerfilHeader = styled.div`
    display: flex;
    height: 138px;
    align-items: center;

    border: 1px solid #e4e4e4;
    border-radius: 24px;
`

const PerfilHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 742px;
    height: 116px;
    align-items: center;
    gap: 16px;
    align-self: center;
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 14px;
`

const PerfilContent = styled.div`
    border: 1px solid #e4e4e4;
    border-radius: 24px;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
`
const PerfilBottom = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-top: 24px;
`

export default function EditFForm() {
    const [activeTab, setActiveTab] = useState('perfil')
    const {userInfo} = useContext(AuthContext)
    const {orgUsersMetrics, getOrgUsersMetrics, setOrganizationMaxUsages} =
        useContext(HistoryContext)
    const [usersMetrics, setUsersMetrics] = useState<OrgMetrics>()
    const [name, setName] = useState(userInfo?.first_name || '')
    const [invatedName, setInvitedName] = useState('')
    const [invitedLastName, setInvitedLastName] = useState('')
    const [lastName, setLastName] = useState(userInfo?.last_name || '')
    const [email, setEmail] = useState('')
    const [oldPassword, setOldPassword] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [phone, setPhone] = useState(userInfo?.phone)
    const [openModalEmail, setOpenModalEmail] = useState(false)
    const [openModalPassword, setOpenModalPassword] = useState(false)
    const [openModalRemove, setOpenModalRemove] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [openAlert, setOpenAlert] = useState(false)
    const [messageAlert, setMessageAlert] = useState('')
    const api = useMemo(() => new AssistantApi(), [])
    const [idRemove, setIdRemove] = useState('')
    const [emailRemove, setEmailRemove] = useState('')
    const [informacoesEdit, setInformacoesEdit] = useState(false)
    const [splitResourcesConfig, setSplitResourcesConfig] = useState(false)
    const [splitDocsConfig, setSplitDocsConfig] = useState(false)
    const [changedCredits, setChangedCredits] = useState<{
        [guid: string]: {messages?: number; projects?: number}
    }>({})
    const [selectedMonth, setSelectedMonth] = useState<string>()
    const [exceededMessages, setExceededMessages] = useState(false)
    const [exceededDocs, setExceededDocs] = useState(false)
    const [successMessage, setSuccessMessage] = useState(false)
    const [severity, setSeverity] = useState<'success' | 'error'>('success')

    useEffect(() => {
        if (userInfo) {
            setName(userInfo.first_name)
            setLastName(userInfo.last_name)
            setPhone(userInfo.phone)
        }
        if (userInfo.org_admin) {
            getOrgUsersMetrics()
        }
    }, [userInfo])

    useEffect(() => {
        setUsersMetrics(orgUsersMetrics)
        setSplitResourcesConfig(orgUsersMetrics.split_resources)
        setSplitDocsConfig(orgUsersMetrics.split_docs)
        orgUsersMetrics.users_metrics.forEach((user) => {
            setChangedCredits((prev) => ({
                ...prev,
                [user.guid]: {
                    messages: user.usages.messages.max,
                    projects: user.usages.projects.max,
                },
            }))
        })
    }, [orgUsersMetrics])

    const [loadingMonthUsage, setLoadingMonthUsage] = useState(false)
    const loadedMonth = usersMetrics?.month ?? null
    const hasMetrics = !!usersMetrics
    useEffect(() => {
        if (!selectedMonth || !hasMetrics || selectedMonth === loadedMonth) {
            setLoadingMonthUsage(false)
            return
        }
        const controller = new AbortController()
        setLoadingMonthUsage(true)
        api.getOrganizationUsersMetrics(selectedMonth, controller.signal)
            .then((data) => {
                // Mês ausente (fallback do backend) ou diferente do pedido: mantém a tabela
                if (controller.signal.aborted || data.month !== selectedMonth) {
                    return
                }
                setUsersMetrics((prev) => {
                    if (!prev) return prev
                    const byGuid = new Map(
                        data.users_metrics.map((u) => [u.guid, u.month_usages])
                    )
                    return {
                        ...prev,
                        month: data.month,
                        month_used_answers: data.month_used_answers,
                        month_used_docs: data.month_used_docs,
                        users_metrics: prev.users_metrics.map((u) => ({
                            ...u,
                            // Sem registro no mês = consumo zero (não o agregado)
                            month_usages: byGuid.get(u.guid) ?? {
                                messages: 0,
                                documents: 0,
                            },
                        })),
                    }
                })
            })
            .catch((error) => {
                if (controller.signal.aborted) return
                console.log(error)
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoadingMonthUsage(false)
            })
        return () => controller.abort()
    }, [selectedMonth, loadedMonth, hasMetrics, api])

    useEffect(() => {
        if (!usersMetrics) {
            setExceededMessages(false)
            setExceededDocs(false)
            return
        }

        const totalAssignedMessages =
            usersMetrics.users_metrics?.reduce(
                (acc, user) => acc + user.usages.messages.max,
                0
            ) ?? 0

        const totalAssignedProjects =
            usersMetrics.users_metrics?.reduce(
                (acc, user) => acc + user.usages.projects.max,
                0
            ) ?? 0

        const availableMessages = usersMetrics.max_answers ?? 0
        const availableProjects = usersMetrics.max_docs ?? 0

        setExceededMessages(
            splitResourcesConfig && totalAssignedMessages > availableMessages
        )
        setExceededDocs(
            splitDocsConfig && totalAssignedProjects > availableProjects
        )
    }, [splitResourcesConfig, splitDocsConfig, usersMetrics, changedCredits])

    const handleCreditChange = (
        userGuid: string,
        userIndex: number,
        field: 'messages' | 'projects',
        value: number
    ) => {
        setUsersMetrics((prev) => {
            if (!prev) return prev
            const newMetrics = JSON.parse(JSON.stringify(prev))
            newMetrics.users_metrics[userIndex].usages[field].max = value
            return newMetrics
        })

        setChangedCredits((prevChanges) => {
            const userChanges = prevChanges[userGuid] || {}

            return {
                ...prevChanges,
                [userGuid]: {
                    ...userChanges,
                    [field]: value,
                },
            }
        })
    }

    const distributeEqually = (total: number, count: number): number[] => {
        if (count <= 0) return []
        const perUser = Math.ceil(total / count)
        const values = new Array(count).fill(perUser)
        values[count - 1] = Math.max(total - perUser * (count - 1), 0)
        return values
    }

    const handleToggleSplitResources = (checked: boolean) => {
        setSplitResourcesConfig(checked)
        if (!usersMetrics?.users_metrics?.length) return

        const totalMessages = usersMetrics.max_answers ?? 0
        const values = checked
            ? distributeEqually(totalMessages, usersMetrics.users_metrics.length)
            : usersMetrics.users_metrics.map(() => totalMessages)

        usersMetrics.users_metrics.forEach((user, index) => {
            handleCreditChange(user.guid, index, 'messages', values[index])
        })
    }

    const handleToggleSplitDocs = (checked: boolean) => {
        setSplitDocsConfig(checked)
        if (!usersMetrics?.users_metrics?.length) return

        const totalDocs = usersMetrics.max_docs ?? 0
        const values = checked
            ? distributeEqually(totalDocs, usersMetrics.users_metrics.length)
            : usersMetrics.users_metrics.map(() => totalDocs)

        usersMetrics.users_metrics.forEach((user, index) => {
            handleCreditChange(user.guid, index, 'projects', values[index])
        })
    }

    const [openConfirmModal, setOpenConfirmModal] = useState(false)

    const proceedWithChanges = () => {
        setOrganizationMaxUsages(
            changedCredits,
            splitResourcesConfig,
            splitDocsConfig
        )
        setSuccessMessage(true)
        setOpenConfirmModal(false)
    }

    const handleOrganizationMaxUsages = () => {
        if (!usersMetrics) return

        const totalAssignedMessages =
            usersMetrics.users_metrics?.reduce(
                (acc, user) => acc + user.usages.messages.max,
                0
            ) ?? 0

        const totalAssignedProjects =
            usersMetrics.users_metrics?.reduce(
                (acc, user) => acc + user.usages.projects.max,
                0
            ) ?? 0

        const availableMessages = usersMetrics.max_answers ?? 0
        const availableProjects = usersMetrics.max_docs ?? 0

        if (
            totalAssignedMessages < availableMessages ||
            totalAssignedProjects < availableProjects
        ) {
            setOpenConfirmModal(true)
        } else {
            proceedWithChanges()
        }
    }

    const handleClose = () => {
        setOpenModalEmail(false)
        setOpenModalPassword(false)
        setOpenModalRemove(false)
        setOpenAlert(false)
    }

    const getOrgUsersMetrics_ = async () => {
        getOrgUsersMetrics()
    }

    async function inviteUser(
        email: string,
        first_name: string,
        last_name: string
    ) {
        try {
            const data = await api.inviteUserOrganization(
                email,
                first_name,
                last_name
            )
            setSeverity('success')
            setMessageAlert(
                data?.resent
                    ? `Convite reenviado para ${email}.`
                    : 'Convite enviado com sucesso!'
            )
            try {
                await getOrgUsersMetrics_()
            } catch (refreshError) {
                console.error('Erro ao atualizar lista de usuários:', refreshError)
            }
        } catch (error: any) {
            setSeverity('error')
            const detail = error?.response?.data?.detail
            if (typeof detail === 'string' &&
                detail.endsWith('user already registered in this organization')) {
                setMessageAlert(
                    'Este usuário já tem acesso à organização.'
                )
            } else if (typeof detail === 'string' &&
                detail.endsWith('user already exists')) {
                setMessageAlert('Este e-mail já está cadastrado na plataforma.')
            } else if (typeof detail === 'string' &&
                detail.endsWith("you can't invite yourself")) {
                setMessageAlert('Você não pode convidar a si mesmo.')
            } else {
                setMessageAlert(
                    'Erro ao enviar convite. Tente novamente mais tarde.'
                )
            }
        } finally {
            setOpenModalEmail(false)
            setOpenAlert(true)
        }
    }

    async function setNewPasswaord(
        oldPassword: string,
        newPassword: string,
        confirmPassword: string
    ) {
        try {
            if (newPassword !== confirmPassword) {
                alert('A nova senha e a confirmação de senha não coincidem.')
                return
            }

            await api.setNewPassword(oldPassword, newPassword, confirmPassword)
            setOpenModalPassword(false)
            setMessageAlert('Senha alterada com sucesso!')
            setOpenAlert(true)
            console.log('Senha alterada com sucesso!')
        } catch (error: unknown) {
            console.error('Erro ao alterar senha:', error)
            if (
                (error as any)?.response?.data?.detail ===
                'Failed due to Current password is incorrect'
            ) {
                setMessageAlert('Senha atual incorreta.')
            } else {
                setMessageAlert(
                    'Erro ao alterar senha. Tente novamente mais tarde.'
                )
            }
            setSeverity('error')
            setOpenAlert(true)
        }
    }

    async function editUser(
        email?: string,
        first_name?: string,
        last_name?: string,
        password?: string,
        phone?: string,
        user_data_personal_id?: string,
        user_data_address?: string
    ) {
        try {
            await api.UpdateUser(
                email,
                first_name,
                last_name,
                password,
                phone,
                user_data_personal_id,
                user_data_address
            )
            setOpenModalPassword(false)
            setMessageAlert('Usuário editado com sucesso!')
            setSeverity('success')
            setOpenAlert(true)
            console.log('Usuário editado com sucesso!')
        } catch (error) {
            console.error('Erro ao editar usuário:', error)
            setMessageAlert(
                'Erro ao editar usuário. Tente novamente mais tarde.'
            )
            setSeverity('error')
            setOpenAlert(true)
        }
    }

    async function removeUser(user_guid: string) {
        await api.removeUserOrganization(user_guid)
        getOrgUsersMetrics_()
        setOpenModalRemove(false)
    }

    function renderAlert() {
        return (
            <>
                {/* <Alert severity="warning">
                    Você está utilizando seu último crédito disponível.
                </Alert> */}

                {
                    <Alert severity="error">
                        A quantidade de créditos selecionada é maior do que o
                        seu saldo disponível.
                    </Alert>
                }
            </>
        )
    }

    return (
        <Page>
            <Header>
                <div>
                    <Typography variant="h5" sx={{fontWeight: 700, color: '#1f2b3a'}}>Configurações de conta</Typography>
                    <Typography variant="body2" sx={{color: '#5b6b7b', mb: 3}}>
                        Atualize as suas configurações de conta
                    </Typography>
                </div>
            </Header>
            <Body>
                <Menu>
                    <MenuItem
                        isActive={activeTab === 'perfil'}
                        onClick={() => setActiveTab('perfil')}
                    >
                        Meu Perfil
                    </MenuItem>
                    {userInfo.org_admin && (
                        <MenuItem
                            isActive={activeTab === 'permissoes'}
                            onClick={() => setActiveTab('permissoes')}
                        >
                            Usuários
                        </MenuItem>
                    )}
                </Menu>
                {activeTab === 'perfil' && (
                    <PerfilContainer>
                        <p
                            style={{
                                fontFamily: 'Inter',
                                fontWeight: 500,
                                fontSize: '18px',
                                lineHeight: '100%',
                                letterSpacing: '0%',
                                marginLeft: '24px',
                                marginTop: '24px',
                                marginBottom: '24px',
                            }}
                        >
                            Meu Perfil
                        </p>
                        <PerfilHeader>
                            <h4
                                style={{
                                    marginLeft: '24px',
                                    fontSize: '24px',
                                    fontWeight: 400,
                                    fontFamily: 'Roboto',
                                    color: 'black',
                                    display: 'flex',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        width: '64px',
                                        height: '64px',
                                        borderRadius: '50%',
                                        backgroundColor: COLORS.primaria,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '16px',
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            color: 'black',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {userInfo?.first_name[0]}
                                        {userInfo?.last_name[0]}
                                    </Typography>
                                </div>
                                {userInfo?.first_name}
                            </h4>
                        </PerfilHeader>

                        <PerfilContent>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    margin: '24px 24px 16px 24px',
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: '18px',
                                    }}
                                >
                                    Informações pessoais
                                </Typography>
                                <Button
                                    startIcon={<DrawOutlinedIcon />}
                                    onClick={() =>
                                        setInformacoesEdit(!informacoesEdit)
                                    }
                                    variant="text"
                                    sx={{
                                        color: COLORS.primariaEscura,
                                        textTransform: 'none',
                                    }}
                                >
                                    {informacoesEdit ? 'Concluir' : 'Editar'}
                                </Button>
                            </div>

                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '20px',
                                    padding: '0 24px 24px 24px',
                                }}
                            >
                                {/* Nome */}
                                <div>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{mb: 1, color: '#707070'}}
                                    >
                                        Nome
                                    </Typography>
                                    {informacoesEdit ? (
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '8px',
                                            }}
                                        >
                                            <input
                                                type="text"
                                                value={name}
                                                onChange={(e) =>
                                                    setName(e.target.value)
                                                }
                                                style={{
                                                    height: '40px',
                                                    width: '50%',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #e4e4e4',
                                                }}
                                                placeholder="Nome"
                                            />
                                            <input
                                                type="text"
                                                value={lastName}
                                                onChange={(e) =>
                                                    setLastName(e.target.value)
                                                }
                                                style={{
                                                    height: '40px',
                                                    width: '50%',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #e4e4e4',
                                                }}
                                                placeholder="Sobrenome"
                                            />
                                        </div>
                                    ) : (
                                        <Typography variant="body1">
                                            {name} {lastName}
                                        </Typography>
                                    )}
                                </div>

                                {/* CPF */}
                                <div>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{mb: 1, color: '#707070'}}
                                    >
                                        CPF
                                    </Typography>
                                    {informacoesEdit ? (
                                        <input
                                            type="text"
                                            value={''}
                                            onChange={(e) => {
                                                /* handle CPF change */
                                            }}
                                            style={{
                                                height: '40px',
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '1px solid #e4e4e4',
                                            }}
                                            placeholder="CPF"
                                        />
                                    ) : (
                                        <Typography variant="body1">
                                            {'-'}
                                        </Typography>
                                    )}
                                </div>

                                {/* Email */}
                                <div>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{mb: 1, color: '#707070'}}
                                    >
                                        Email
                                    </Typography>
                                    <Typography variant="body1">
                                        {userInfo?.email}
                                    </Typography>
                                </div>

                                {/* Telefone */}
                                <div>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{mb: 1, color: '#707070'}}
                                    >
                                        Telefone
                                    </Typography>
                                    {informacoesEdit ? (
                                        <input
                                            type="text"
                                            value={phone || ''}
                                            onChange={(e) =>
                                                setPhone(e.target.value)
                                            }
                                            style={{
                                                height: '40px',
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '1px solid #e4e4e4',
                                            }}
                                            placeholder="Telefone"
                                        />
                                    ) : (
                                        <Typography variant="body1">
                                            {phone || '-'}
                                        </Typography>
                                    )}
                                </div>
                            </div>
                        </PerfilContent>

                        <PerfilBottom>
                            <Button
                                variant="outlined"
                                style={{
                                    backgroundColor: '#FFFFFF',
                                    color: 'black',
                                    borderColor: '#D9D9D9',

                                    textTransform: 'none',
                                }}
                                onClick={() => {
                                    setOpenModalPassword(true)
                                }}
                                sx={{marginRight: '16px'}}
                            >
                                Mudar Senha
                            </Button>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: '#012441',
                                    color: 'white',
                                    width: '152px',
                                    textTransform: 'none',
                                }}
                                onClick={() => {
                                    editUser(
                                        undefined,
                                        name,
                                        lastName,
                                        undefined,
                                        phone
                                    )
                                }}
                                sx={{marginRight: '24px'}}
                            >
                                Salvar
                            </Button>
                        </PerfilBottom>
                    </PerfilContainer>
                )}

                {userInfo.org_admin && activeTab === 'permissoes' && (
                    <>
                        <PerfilContainer style={{marginTop: '24px'}}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '40px',
                                }}
                            >
                                <h1
                                    style={{
                                        fontFamily: 'Inter',
                                        fontWeight: 500,
                                        fontSize: '22px',
                                        lineHeight: '100%',
                                        letterSpacing: '0%',
                                        textAlign: 'left',

                                        marginTop: '24px',
                                    }}
                                >
                                    Gerenciamento de Usuários
                                </h1>
                                <Button
                                    variant="outlined"
                                    style={{
                                        backgroundColor: 'transparent',
                                        color: COLORS.primariaEscura,
                                        width: '210px',
                                        textTransform: 'none',
                                        marginRight: '24px',
                                        borderRadius: '8px',
                                    }}
                                    onClick={() => {
                                        setOpenModalEmail(true)
                                    }}
                                >
                                    <PersonAddAltOutlinedIcon /> Adicionar novo
                                    membro
                                </Button>
                            </div>
                            <MonthlyUsageReport rosterVersion={usersMetrics?.users_metrics?.map((user) => user.guid).join(',')} onMonthChange={setSelectedMonth} />
                            <Typography variant="h6" component="h2" sx={{mb: 2}}>Distribuição de créditos</Typography>
                            <div
                                style={{
                                    marginBottom: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '16px 16px 16px 0',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        marginRight: '16px',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: 500, color: '#333'}}
                                    >
                                        Créditos da organização:
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        backgroundColor: COLORS.secundaria,
                                        padding: '18px',
                                        borderRadius: '12px',
                                        marginRight: '16px',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontWeight: 600,
                                            color: '#012441',
                                        }}
                                    >
                                        <img
                                            src={GreenCoins}
                                            alt="Coins"
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                            }}
                                            color={COLORS.primariaEscura}
                                        />
                                        {usersMetrics?.max_answers ?? 0}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: 500, color: '#333'}}
                                    >
                                        Créditos Consultas
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        backgroundColor: COLORS.primaria,
                                        padding: '18px',
                                        borderRadius: '12px',
                                        marginRight: '16px',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontWeight: 600,
                                            color: '#012441',
                                        }}
                                    >
                                        <img
                                            src={Coins}
                                            alt="Coins"
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                            }}
                                        />
                                        {usersMetrics?.max_docs ?? 0}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: 500, color: '#333'}}
                                    >
                                        Créditos Documentos
                                    </Typography>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '24px',
                                    padding: '16px 16px 16px 0',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}
                                >
                                    <Switch
                                        checked={splitResourcesConfig}
                                        onChange={(e) =>
                                            handleToggleSplitResources(
                                                e.target.checked
                                            )
                                        }
                                        size="medium"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked':
                                                {
                                                    color: COLORS.primariaEscura,
                                                },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                                                {
                                                    backgroundColor:
                                                        COLORS.primariaEscura,
                                                },
                                        }}
                                    />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: 'Inter',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                            lineHeight: '100%',
                                            letterSpacing: '0%',
                                            textAlign: 'center',
                                            color: '#757575',
                                        }}
                                    >
                                        Dividir créditos de consultas
                                        manualmente
                                    </Typography>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}
                                >
                                    <Switch
                                        checked={splitDocsConfig}
                                        onChange={(e) =>
                                            handleToggleSplitDocs(
                                                e.target.checked
                                            )
                                        }
                                        size="medium"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked':
                                                {
                                                    color: COLORS.primariaEscura,
                                                },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                                                {
                                                    backgroundColor:
                                                        COLORS.primariaEscura,
                                                },
                                        }}
                                    />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: 'Inter',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                            lineHeight: '100%',
                                            letterSpacing: '0%',
                                            textAlign: 'center',
                                            color: '#757575',
                                        }}
                                    >
                                        Dividir créditos de documentos
                                        manualmente
                                    </Typography>
                                </div>
                            </div>
                            <div
                                style={{
                                    border: '1px solid #e4e4e4',
                                    borderRadius: '10px',
                                    overflowX: 'auto',
                                    marginTop: '16px',
                                }}
                            >
                                <table
                                    style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        borderStyle: 'hidden',
                                    }}
                                >
                                    <thead
                                        style={{
                                            backgroundColor: '#F6F6F696',
                                            height: '48px',
                                        }}
                                    >
                                        <tr>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                Nome
                                            </th>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                E-mail
                                            </th>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                Consultas
                                            </th>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                Documentos
                                            </th>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                Créditos consumidos
                                                {loadingMonthUsage && (
                                                    <CircularProgress
                                                        size={12}
                                                        style={{
                                                            marginLeft: '8px',
                                                            verticalAlign:
                                                                'middle',
                                                        }}
                                                    />
                                                )}
                                            </th>
                                            <th
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    textAlign: 'left',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                Ação
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usersMetrics?.users_metrics?.map(
                                            (user, index) => {
                                                return (
                                                    <tr
                                                        key={user.guid}
                                                        style={{
                                                            height: '50px',
                                                        }}
                                                    >
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                            }}
                                                        >
                                                            {user?.first_name}{' '}
                                                            {user?.last_name}
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                            }}
                                                        >
                                                            {user?.email}
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    border: `1px solid ${
                                                                        exceededMessages
                                                                            ? 'red'
                                                                            : '#e4e4e4'
                                                                    }`,
                                                                    borderRadius:
                                                                        '61px',
                                                                    padding:
                                                                        '4px 8px',
                                                                    width: 'fit-content',
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        GreenCoins
                                                                    }
                                                                    alt="Coins"
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px',
                                                                    }}
                                                                />
                                                                <input
                                                                    type="number"
                                                                    disabled={
                                                                        !splitResourcesConfig
                                                                    }
                                                                    value={
                                                                        user
                                                                            .usages
                                                                            .messages
                                                                            .max
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const newValue =
                                                                            parseInt(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            ) ||
                                                                            0

                                                                        handleCreditChange(
                                                                            user.guid,
                                                                            index,
                                                                            'messages',
                                                                            newValue
                                                                        )
                                                                    }}
                                                                    style={{
                                                                        width: '60px',
                                                                        padding:
                                                                            '4px 8px',
                                                                        borderRadius:
                                                                            '80px',
                                                                        border: 'none',
                                                                        textAlign:
                                                                            'center',
                                                                        backgroundColor:
                                                                            'transparent',
                                                                    }}
                                                                    min="0"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    border: `1px solid ${
                                                                        exceededDocs
                                                                            ? 'red'
                                                                            : '#e4e4e4'
                                                                    }`,
                                                                    borderRadius:
                                                                        '61px',
                                                                    padding:
                                                                        '4px 8px',
                                                                    width: 'fit-content',
                                                                }}
                                                            >
                                                                <img
                                                                    src={Coins}
                                                                    alt="Coins"
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px',
                                                                    }}
                                                                />
                                                                <input
                                                                    type="number"
                                                                    disabled={
                                                                        !splitDocsConfig
                                                                    }
                                                                    value={
                                                                        user
                                                                            .usages
                                                                            .projects
                                                                            .max
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const newValue =
                                                                            parseInt(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            ) ||
                                                                            0

                                                                        handleCreditChange(
                                                                            user.guid,
                                                                            index,
                                                                            'projects',
                                                                            newValue
                                                                        )
                                                                    }}
                                                                    style={{
                                                                        width: '60px',
                                                                        padding:
                                                                            '4px 8px',
                                                                        borderRadius:
                                                                            '80px',
                                                                        border: 'none',
                                                                        textAlign:
                                                                            'center',
                                                                        backgroundColor:
                                                                            'transparent',
                                                                    }}
                                                                    min="0"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                                fontFamily:
                                                                    'Inter',
                                                                fontSize:
                                                                    '14px',
                                                                opacity:
                                                                    loadingMonthUsage
                                                                        ? 0.4
                                                                        : 1,
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    gap: '16px',
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'center',
                                                                        gap: '4px',
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            GreenCoins
                                                                        }
                                                                        alt="Green Coins"
                                                                        style={{
                                                                            width: '16px',
                                                                            height: '16px',
                                                                        }}
                                                                    />
                                                                    {user
                                                                        .month_usages
                                                                        ?.messages ??
                                                                        user
                                                                            .usages
                                                                            .messages
                                                                            .current}{' '}
                                                                    Consultas
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        gap: '4px',
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            Coins
                                                                        }
                                                                        alt="Coins"
                                                                        style={{
                                                                            width: '16px',
                                                                            height: '16px',
                                                                        }}
                                                                    />
                                                                    {user
                                                                        .month_usages
                                                                        ?.documents ??
                                                                        user
                                                                            .usages
                                                                            .projects
                                                                            .current}{' '}
                                                                    Documentos
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottom:
                                                                    '1px solid #e4e4e4',
                                                                padding: '8px',
                                                            }}
                                                        >
                                                            {!user?.org_admin &&
                                                                usersMetrics?.users_metrics?.indexOf(
                                                                    user
                                                                ) !== 0 && (
                                                                    <Button
                                                                        variant="outlined"
                                                                        style={{
                                                                            backgroundColor:
                                                                                '#ffffff',
                                                                            color: '#ff4444',
                                                                            border: 'none',
                                                                            minWidth:
                                                                                '40px',
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            padding:
                                                                                '8px',
                                                                        }}
                                                                        onClick={() => {
                                                                            setOpenModalRemove(
                                                                                true
                                                                            )
                                                                            setIdRemove(
                                                                                user.guid
                                                                            )
                                                                            setEmailRemove(
                                                                                user.email
                                                                            )
                                                                        }}
                                                                    >
                                                                        <PersonRemoveOutlinedIcon />
                                                                    </Button>
                                                                )}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr
                                            style={{
                                                backgroundColor: '#F6F6F696',
                                                height: '40px',
                                            }}
                                        >
                                            <td
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            ></td>
                                            <td
                                                style={{
                                                    borderBottom:
                                                        '1px solid #e4e4e4',
                                                    padding: '8px',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            ></td>
                                            <td
                                                style={{
                                                    padding: '8px',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                }}
                                            >
                                                <img
                                                    src={GreenCoins}
                                                    alt="Coins"
                                                    style={{
                                                        width: '16px',
                                                        height: '16px',
                                                    }}
                                                />
                                                {(splitResourcesConfig
                                                    ? usersMetrics?.users_metrics?.reduce(
                                                          (acc, user) =>
                                                              acc +
                                                              user.usages
                                                                  .messages
                                                                  .max,
                                                          0
                                                      )
                                                    : usersMetrics?.max_answers) ??
                                                    0}{' '}
                                                Créditos
                                            </td>
                                            <td
                                                style={{
                                                    padding: '8px',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                }}
                                            >
                                                <img
                                                    src={Coins}
                                                    alt="Coins"
                                                    style={{
                                                        width: '16px',
                                                        height: '16px',
                                                    }}
                                                />{' '}
                                                {(splitDocsConfig
                                                    ? usersMetrics?.users_metrics?.reduce(
                                                          (acc, user) =>
                                                              acc +
                                                              user.usages
                                                                  .projects
                                                                  .max,
                                                          0
                                                      )
                                                    : usersMetrics?.max_docs) ??
                                                    0}{' '}
                                                Créditos
                                            </td>

                                            <td
                                                style={{
                                                    padding: '8px',
                                                    fontFamily: 'Inter',
                                                    fontWeight: 600,
                                                    fontSize: '14px',
                                                    lineHeight: '100%',
                                                    letterSpacing: '0%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '16px',
                                                    opacity: loadingMonthUsage
                                                        ? 0.4
                                                        : 1,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                    }}
                                                >
                                                    <img
                                                        src={GreenCoins}
                                                        alt="Green Coins"
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                        }}
                                                    />
                                                    {(usersMetrics?.month
                                                        ? usersMetrics.month_used_answers
                                                        : undefined) ??
                                                        usersMetrics?.users_metrics?.reduce(
                                                            (acc, user) =>
                                                                acc +
                                                                user.usages
                                                                    .messages
                                                                    .current,
                                                            0
                                                        ) ??
                                                        0}{' '}
                                                    Créditos
                                                </div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                    }}
                                                >
                                                    <img
                                                        src={Coins}
                                                        alt="Coins"
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                        }}
                                                    />
                                                    {(usersMetrics?.month
                                                        ? usersMetrics.month_used_docs
                                                        : undefined) ??
                                                        usersMetrics?.users_metrics?.reduce(
                                                            (acc, user) =>
                                                                acc +
                                                                user.usages
                                                                    .projects
                                                                    .current,
                                                            0
                                                        ) ??
                                                        0}{' '}
                                                    Créditos
                                                </div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            {(exceededMessages || exceededDocs) && (
                                <Alert
                                    style={{
                                        margin: '16px 0',
                                    }}
                                    severity="error"
                                >
                                    A quantidade de créditos selecionada é maior
                                    do que o seu saldo disponível.
                                </Alert>
                            )}
                            {successMessage && (
                                <Alert
                                    style={{
                                        margin: '16px 0',
                                    }}
                                    severity="success"
                                    onClose={() => setSuccessMessage(false)}
                                >
                                    Alterações aplicadas com sucesso!
                                </Alert>
                            )}
                            <PerfilBottom>
                                <Button
                                    variant="outlined"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        color: COLORS.primariaEscura,
                                        borderColor: COLORS.primariaEscura,
                                        width: '111px',
                                        textTransform: 'none',
                                    }}
                                    onClick={() => {
                                        setUsersMetrics(orgUsersMetrics)
                                        setChangedCredits({})
                                        setSplitResourcesConfig(
                                            orgUsersMetrics.split_resources
                                        )
                                        setSplitDocsConfig(
                                            orgUsersMetrics.split_docs
                                        )
                                        setExceededMessages(false)
                                        setExceededDocs(false)
                                        setSuccessMessage(false)
                                    }}
                                    sx={{marginRight: '16px'}}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    disabled={exceededMessages || exceededDocs}
                                    variant="contained"
                                    style={{
                                        backgroundColor:
                                            exceededMessages || exceededDocs
                                                ? COLORS.primaria
                                                : COLORS.primariaEscura,
                                        color: 'white',
                                        width: '152px',
                                        textTransform: 'none',
                                    }}
                                    onClick={() => {
                                        handleOrganizationMaxUsages()
                                    }}
                                >
                                    Aplicar alterações
                                </Button>
                            </PerfilBottom>
                        </PerfilContainer>
                    </>
                )}
            </Body>

            <Modal
                open={openModalEmail}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '8px',
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{mb: 2}}
                    >
                        Insira o e-mail do usuário
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        style={{
                            color: '#707070',
                            fontSize: '16px',
                            fontWeight: 400,
                        }}
                        sx={{mb: 2}}
                    >
                        Digite o e-mail abaixo para enviar o convite
                    </Typography>
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        placeholder="E-mail"
                        style={{
                            width: '100%',
                            padding: '8px',
                            marginBottom: '16px',
                            borderRadius: '4px',
                            border: '1px solid #e4e4e4',
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            gap: '16px',
                            justifyContent: 'flex-end',
                            width: '100%',
                            marginBottom: '16px',
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Nome"
                            value={invatedName}
                            onChange={(e) => setInvitedName(e.target.value)}
                            style={{
                                width: '48%',
                                padding: '8px',
                                borderRadius: '4px',
                                border: '1px solid #e4e4e4',
                            }}
                        />
                        <input
                            type="text"
                            placeholder="Sobrenome"
                            value={invitedLastName}
                            onChange={(e) => setInvitedLastName(e.target.value)}
                            style={{
                                width: '48%',
                                padding: '8px',
                                borderRadius: '4px',
                                border: '1px solid #e4e4e4',
                            }}
                        />
                    </div>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                textTransform: 'none',
                                border: 'none',
                                color: 'red',
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                border: 'none',
                            }}
                            onClick={async () => {
                                await inviteUser(email, invatedName, invitedLastName)
                            }}
                        >
                            Enviar
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={openModalRemove}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '8px',
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{mb: 2}}
                    >
                        Deseja remover o usuário?
                    </Typography>
                    <Typography
                        style={{
                            color: '#707070',
                            fontSize: '16px',
                            fontWeight: 400,
                        }}
                        id="modal-modal-description"
                        sx={{mb: 2}}
                    >
                        Remover o usuário {emailRemove}
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                textTransform: 'none',
                                color: 'red',
                                border: 'none',
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                border: 'none',
                            }}
                            onClick={() => {
                                removeUser(idRemove)
                            }}
                        >
                            Sim, Remover
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={openModalPassword}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',

                        boxShadow: 24,
                        p: 4,
                        borderRadius: '8px',
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{mb: 2}}
                    >
                        Mudar senha do usuário
                    </Typography>
                    <Typography
                        style={{
                            color: '#707070',
                            fontSize: '16px',
                            fontWeight: 400,
                        }}
                        id="modal-modal-description"
                        sx={{mb: 2}}
                    >
                        Digite a nova senha do usuário
                    </Typography>
                    <div style={{position: 'relative', width: '100%'}}>
                        <input
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Senha atual "
                            style={{
                                width: '100%',
                                padding: '8px',
                                marginBottom: '8px',
                                borderRadius: '4px',
                                border: '1px solid #e4e4e4',
                            }}
                        />

                        <input
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Nova senha"
                            style={{
                                width: '100%',
                                padding: '8px',
                                marginBottom: '8px',
                                borderRadius: '4px',
                                border: '1px solid #e4e4e4',
                            }}
                        />
                        <input
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Confirme a nova senha"
                            style={{
                                width: '100%',
                                padding: '8px',
                                marginBottom: '8px',
                                borderRadius: '4px',
                                border: '1px solid #e4e4e4',
                            }}
                        />
                        <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: 'absolute',
                                right: '8px',
                                top: '15%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#707070',
                            }}
                        >
                            {!showPassword ? (
                                <VisibilityOutlinedIcon />
                            ) : (
                                <VisibilityOffOutlinedIcon />
                            )}
                        </span>
                    </div>
                    {password && (
                        <div style={{marginTop: '4px'}}>
                            {password !== confirmPassword && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    As senhas não coincidem.
                                </Typography>
                            )}
                            {!/[A-Z]/.test(password) && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    A senha deve conter pelo menos uma letra
                                    maiúscula.
                                </Typography>
                            )}
                            {!/[a-z]/.test(password) && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    A senha deve conter pelo menos uma letra
                                    minúscula.
                                </Typography>
                            )}
                            {!/[0-9]/.test(password) && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    A senha deve conter pelo menos um número.
                                </Typography>
                            )}
                            {!/[@$!%*?&#]/.test(password) && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    A senha deve conter pelo menos um caractere
                                    especial.
                                </Typography>
                            )}
                            {password.length < 8 && (
                                <Typography
                                    variant="subtitle2"
                                    style={{
                                        color: 'red',
                                        fontSize: '14px',
                                    }}
                                >
                                    A senha deve ter pelo menos 8 caracteres.
                                </Typography>
                            )}
                        </div>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                textTransform: 'none',
                                border: 'none',
                                color: 'red',
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                border: 'none',
                            }}
                            onClick={() => {
                                setNewPasswaord(
                                    oldPassword,
                                    password,
                                    confirmPassword
                                )
                            }}
                            disabled={
                                !password ||
                                !/[A-Z]/.test(password) ||
                                !/[a-z]/.test(password) ||
                                !/[0-9]/.test(password) ||
                                !/[@$!%*?&#]/.test(password) ||
                                password.length < 8
                            }
                        >
                            Salvar senha
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={openConfirmModal}
                onClose={() => setOpenConfirmModal(false)}
                aria-labelledby="confirm-modal-title"
                aria-describedby="confirm-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '8px',
                    }}
                >
                    <Typography
                        id="confirm-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{mb: 2}}
                    >
                        Confirmar alterações
                    </Typography>
                    <Typography
                        id="confirm-modal-description"
                        sx={{mb: 3, color: '#707070'}}
                    >
                        Você não distribuiu todos os créditos disponíveis. Os
                        créditos restantes ficarão retidos na conta da
                        organização. Deseja continuar?
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => setOpenConfirmModal(false)}
                            sx={{
                                textTransform: 'none',
                                color: COLORS.primariaEscura,
                                borderColor: COLORS.primariaEscura,
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={proceedWithChanges}
                            sx={{
                                textTransform: 'none',
                                backgroundColor: COLORS.primariaEscura,
                            }}
                        >
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                open={openAlert}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    variant="filled"
                    sx={{width: '100%'}}
                >
                    {messageAlert}
                </Alert>
            </Snackbar>
        </Page>
    )
}
